import React from 'react';

const MainContext = React.createContext({
    matchData: null,
    setMatchData: function(matchData) {
        this.matchData = matchData;
    }
});

export default MainContext;